import React from 'react';

export const InfoIcon = () => {
    return (
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.5 4C7.224 4 7 4.224 7 4.5V4.656C7 4.933 7.224 5.156 7.5 5.156C7.776 5.156 8 4.933 8 4.656V4.5C8 4.224 7.776 4 7.5 4ZM7.5 6C7.224 6 7 6.224 7 6.5V10.5C7 10.776 7.224 11 7.5 11C7.776 11 8 10.776 8 10.5V6.5C8 6.224 7.776 6 7.5 6ZM7.5 14C3.916 14 1 11.084 1 7.5C1 3.916 3.916 1 7.5 1C11.084 1 14 3.916 14 7.5C14 11.084 11.084 14 7.5 14ZM7.5 0C3.364 0 0 3.364 0 7.5C0 11.636 3.364 15 7.5 15C11.636 15 15 11.636 15 7.5C15 3.364 11.636 0 7.5 0Z"
                fill="#C2C2C2"
            />
        </svg>
    );
};
